import {
  SET_COTACOES,
  SET_VIEW_TYPE,
  SET_SELECTED_STATUS,
  SET_FORNECEDORES,
  SET_COTACOES_ITENS,
  CLEAR,
  SET_SHOW_ESPECIFICACAO,
  SET_SHOW_ESPECIFICACAO_FORNECEDOR,
  SET_SHOW_PRECO_SEM_ICMS,
  SET_SHOW_PRECO_SEM_DIFAL,
  SET_SHOW_PRECO_SEM_IPI,
  SET_TIPO_VISUALIZACAO,
  SET_SHOW_PERCENTUTAL_ICMS,
  SET_SHOW_PRECO_TARGET,
  SET_SITUACAO,
} from './mutations.type';

export default {
  [SET_COTACOES](state, cotacoes) {
    state.cotacoes = cotacoes;
  },
  [SET_VIEW_TYPE](state, viewType) {
    state.viewType = viewType;
  },
  [SET_SELECTED_STATUS](state, selectedStatus) {
    state.selectedStatus = selectedStatus;
  },
  [SET_FORNECEDORES](state, data) {
    state.fornecedores = data;
  },
  [SET_COTACOES_ITENS](state, data) {
    state.cotacoesItens = data;
  },
  [SET_SHOW_ESPECIFICACAO](state, data) {
    state.showEspecificacao = data;
  },
  [SET_SHOW_ESPECIFICACAO_FORNECEDOR](state, data) {
    state.showEspecificacaoFornecedor = data;
  },
  [SET_SHOW_PRECO_SEM_ICMS](state, data) {
    state.showPrecoSemIcms = data;
  },
  [SET_SHOW_PRECO_SEM_DIFAL](state, data) {
    state.showPrecoComDifal = data;
  },
  [SET_SHOW_PRECO_SEM_IPI](state, data) {
    state.showPrecoComIpi = data;
  },
  [SET_TIPO_VISUALIZACAO](state, data) {
    state.tipoVisualizacao = data;
  },
  [SET_SHOW_PERCENTUTAL_ICMS](state, data) {
    state.showPercentualIcms = data;
  },
  [SET_SHOW_PRECO_TARGET](state, data) {
    state.showPrecoTarget = data;
  },
  [CLEAR](state) {
    state.fornecedores = null;
    state.cotacoesItens = null;
  },
  [SET_SITUACAO](state, data) {
    state.situacao = data;
  },
};
